<template>
  <div class="hotel-form">
    <b-card>
      <template #header>
        <h2 class="mb-0">
          {{ isEdit ? $t("hotels.edit_title") : $t("hotels.create_title") }}
        </h2>
      </template>

      <b-form @submit.prevent="handleSubmit" :validated="validated" novalidate>

        <b-form-group :label="$t('hotels.form.hotel_group_label')" label-for="hotel_group_id"
          :state="formErrors.has('hotel_group_id') ? false : null" :invalid-feedback="formErrors.first('hotel_group_id')">
          <treeselect 
            id="hotel_group_id"
            v-model="formFields.hotel_group_id" 
            :options="hotelGroupOptions"
            :normalizer="normalizer" :state="formErrors.has('hotel_group_id') ? false : null"
            :class="formErrors.has('hotel_group_id') ? 'error-input' : ''" placeholder="Select hotel group"
            @input="removeError('hotel_group_id')"></treeselect>
        </b-form-group>

        <b-form-group id="name-group" :label="$t('hotels.form.name_label')" label-for="name" :state="formErrors.has('name') ? false : null"
          :invalid-feedback="formErrors.first('name')">
          <b-form-input id="name" v-model="formFields.name" :state="formErrors.has('name') ? false : null" required
            @input="removeError('name')"></b-form-input>
        </b-form-group>

        <b-form-group id="is_active-group" :label="$t('hotels.form.status_label')" label-for="is_active"
          :state="formErrors.has('is_active') ? false : null" :invalid-feedback="formErrors.first('is_active')">
          <b-form-select id="is_active" v-model="formFields.is_active" :options="statusOptions"
            :state="formErrors.has('is_active') ? false : null" required @input="removeError('is_active')"></b-form-select>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.description_label')" label-for="description"
          :state="formErrors.has('description') ? false : null" :invalid-feedback="formErrors.first('description')">
          <b-form-textarea id="description" v-model="formFields.description" :state="formErrors.has('description') ? false : null"
            @input="removeError('description')" rows="2"></b-form-textarea>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.contact_email_label')" label-for="contact_email"
          :state="formErrors.has('contact_email') ? false : null" :invalid-feedback="formErrors.first('contact_email')">
          <b-form-input id="contact_email" v-model="formFields.contact_email" type="email"
            :state="formErrors.has('contact_email') ? false : null" @input="removeError('contact_email')"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.phone_label')" label-for="phone" :state="formErrors.has('phone') ? false : null"
          :invalid-feedback="formErrors.first('phone')">
          <b-form-input id="phone" v-model="formFields.phone" :state="formErrors.has('phone') ? false : null"
            @input="removeError('phone')"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.rating_label')" label-for="rating" :state="formErrors.has('rating') ? false : null"
          :invalid-feedback="formErrors.first('rating')">
          <b-form-input id="rating" v-model="formFields.rating" type="number" min="0" max="5" step="0.1"
            :state="formErrors.has('rating') ? false : null" @input="removeError('rating')"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.check_in_time_label')" label-for="check_in_time"
          :state="formErrors.has('check_in_time') ? false : null" :invalid-feedback="formErrors.first('check_in_time')">
          <b-form-input id="check_in_time" v-model="formFields.check_in_time" type="time"
            :state="formErrors.has('check_in_time') ? false : null" @input="removeError('check_in_time')"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.check_out_time_label')" label-for="check_out_time"
          :state="formErrors.has('check_out_time') ? false : null" :invalid-feedback="formErrors.first('check_out_time')">
          <b-form-input id="check_out_time" v-model="formFields.check_out_time" type="time"
            :state="formErrors.has('check_out_time') ? false : null" @input="removeError('check_out_time')"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.address_label')" label-for="address" :state="formErrors.has('address') ? false : null"
          :invalid-feedback="formErrors.first('address')">
          <b-form-input id="address" v-model="formFields.address" :state="formErrors.has('address') ? false : null"
            @input="removeError('address')"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.country_label')" label-for="country_id" :state="formErrors.has('country_id') ? false : null"
          :invalid-feedback="formErrors.first('country_id')">
          <b-form-select id="country_id" v-model="formFields.country_id" :options="countryOptions"
            :state="formErrors.has('country_id') ? false : null" @change="onCountryChange"></b-form-select>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.state_label')" label-for="state_id" :state="formErrors.has('state_id') ? false : null"
          :invalid-feedback="formErrors.first('state_id')">
          <b-form-select id="state_id" v-model="formFields.state_id" :options="stateOptions"
            :state="formErrors.has('state_id') ? false : null" @change="onStateChange"></b-form-select>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.city_label')" label-for="city_id" :state="formErrors.has('city_id') ? false : null"
          :invalid-feedback="formErrors.first('city_id')">
          <b-form-select id="city_id" v-model="formFields.city_id" :options="cityOptions" :state="formErrors.has('city_id') ? false : null"
            @input="removeError('city_id')"></b-form-select>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.latitude_label')" label-for="latitude" :state="formErrors.has('latitude') ? false : null"
          :invalid-feedback="formErrors.first('latitude')">
          <b-form-input id="latitude" v-model="formFields.latitude" type="number" step="any"
            :state="formErrors.has('latitude') ? false : null" @input="removeError('latitude')"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('hotels.form.longitude_label')" label-for="longitude" :state="formErrors.has('longitude') ? false : null"
          :invalid-feedback="formErrors.first('longitude')">
          <b-form-input id="longitude" v-model="formFields.longitude" type="number" step="any"
            :state="formErrors.has('longitude') ? false : null" @input="removeError('longitude')"></b-form-input>
        </b-form-group>
          <b-form-group label="Tax Type" label-for="tax_type" :state="formErrors.has('tax_type') ? false : null" :invalid-feedback="formErrors.first('tax_type')">
              <b-form-select
                  id="tax_type"
                  v-model="formFields.tax_type"
                  :options="[
                      { value: 'percentage', text: 'Percentage (%)' },
                      { value: 'fixed_amount', text: 'Fixed Amount' }
                    ]"
                  :state="formErrors.has('tax_type') ? false : null"
                  @change="removeError('tax_type')"
              ></b-form-select>
          </b-form-group>

          <!-- Tax Apply Per -->
          <b-form-group label="Apply Tax" label-for="tax_apply_per" :state="formErrors.has('tax_apply_per') ? false : null" :invalid-feedback="formErrors.first('tax_apply_per')">
              <b-form-select
                  id="tax_apply_per"
                  v-model="formFields.tax_apply_per"
                  :options="[
                      { value: 'per_booking', text: 'On Total Bill' },
                      { value: 'per_night', text: 'Per Night' },
                      { value: 'per_person', text: 'Per Person' }
                    ]"
                  :state="formErrors.has('tax_apply_per') ? false : null"
                  @change="removeError('tax_apply_per')"
              ></b-form-select>
          </b-form-group>

          <!-- Tax Value -->
          <b-form-group label="Tax Value" label-for="tax_value" :state="formErrors.has('tax_value') ? false : null" :invalid-feedback="formErrors.first('tax_value')">
              <b-form-input
                  id="tax_value"
                  v-model="formFields.tax_value"
                  type="number"
                  min="0"
                  step="0.01"
                  :placeholder="formFields.tax_type === 'percentage' ? 'Enter %' : 'Enter amount'"
                  :state="formErrors.has('tax_value') ? false : null"
                  @input="removeError('tax_value')"
              ></b-form-input>
          </b-form-group>
        <b-form-group label="Booking Confirmation" label-for="booking_confirmation"
          :state="formErrors.has('booking_confirmation') ? false : null" :invalid-feedback="formErrors.first('booking_confirmation')">
          <b-form-radio-group id="booking_confirmation" v-model="formFields.booking_confirmation" :options="[
            { text: 'Auto', value: 'auto' },
            { text: 'Manual', value: 'manual' }
          ]" name="bookingConfirmationOptions" @change="removeError('booking_confirmation')"
            :state="formErrors.has('booking_confirmation') ? false : null" buttons button-variant="outline-primary"></b-form-radio-group>
        </b-form-group>
        <b-form-group label="Booking Verification" label-for="booking_verification"
          :state="formErrors.has('booking_verification') ? false : null" :invalid-feedback="formErrors.first('booking_verification')">
          <b-form-radio-group id="booking_verification" v-model="formFields.booking_verification" :options="[
            { text: 'Yes', value: 1 },
            { text: 'No', value: 0 }
          ]" name="bookingVerificationOptions" @change="removeError('booking_verification')"
            :state="formErrors.has('booking_verification') ? false : null" buttons button-variant="outline-primary"></b-form-radio-group>
        </b-form-group>
        <b-form-group 
          label="Images" 
          label-for="images"
          :state="formErrors.has('images') ? false : null" 
          :invalid-feedback="formErrors.first('images')"
        >
          <b-form-file 
            id="room_images"
            ref="fileInput"
            multiple accept="image/*" 
            @change="handleImageChange" />

          <div class="image-preview-wrapper mt-3 d-flex flex-wrap gap-2">
            <!-- Existing images from server -->
            <div v-for="(img, index) in existingImages" :key="'existing-' + img.id"
              class="preview-box position-relative">
              <img :src="img.path" class="preview-image" />
              <button type="button" class="remove-btn" @click="removeExistingImage(img, index)">
                &times;
              </button>
            </div>
            <!-- Newly selected images -->
            <div v-for="(img, index) in previewImages" :key="'new-' + index" class="preview-box position-relative">
              <img :src="img" class="preview-image" />
              <button type="button" class="remove-btn" @click="removeImage(index)">
                &times;
              </button>
            </div>
          </div>

        </b-form-group>

        <div class="d-flex gap-2 mt-4">
          <b-button type="submit" variant="primary" :disabled="loader">
            <b-spinner small v-if="loader" class="mr-1"></b-spinner>
            {{ loader ? $t("common.saving") : $t("common.save") }}
          </b-button>
          <b-button variant="secondary" @click="cancel">{{
            $t("common.cancel")
          }}</b-button>
        </div>

        <!-- Form Level Error Message -->
        <div v-if="formLevelError" class="mt-3">
          <b-alert show variant="danger" class="mb-0">
            {{ formLevelError }}
          </b-alert>
        </div>
      </b-form>
    </b-card>

    <!-- Delete Image Confirmation Modal -->
    <b-modal v-model="showDeleteImageModal" :title="$t('common.delete_image')" @ok="confirmDeleteImage"
      ok-variant="danger" :ok-title="$t('common.delete')" :cancel-title="$t('common.cancel')">
      <p>{{ $t('hotels.delete_image_confirmation') }}</p>
      <div class="d-flex align-items-center">
        <img :src="imageToDelete.path" :alt="imageToDelete.name" class="image-to-delete me-3" />
        <div>
          <strong>{{ imageToDelete.name || 'Image' }}</strong>
          <br>
          <small class="text-muted">{{ $t('hotels.image_will_be_removed_on_save') }}</small>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/Util/Request";
import NotifyMixin from "@/Util/NotifyMixin";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Error from "@/Util/Error";
import { mapGetters } from "vuex";

export default {
  name: "HotelForm",
  mixins: [NotifyMixin],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    Treeselect,
  },

  data() {
    return {
      validated: false,
      formErrors: new Error({}),
      formLevelError: "",
      images: [],
      previewImages: [],
      existingImages: [],
      removedImageIds: [],
      showDeleteImageModal: false,
      imageToDelete: {},
      imageToDeleteIndex: null,
      formFields: {
        hotel_group_id: null,
        name: "",
        description: "",
        contact_email: "",
        phone: "",
        rating: "",
        check_in_time: "",
        check_out_time: "",
        address: "",
        city_id: "",
        state_id: "",
        country_id: "",
        latitude: "",
        longitude: "",
        is_active: 1,
        booking_confirmation: 'auto',
        booking_verification: 1,
          tax_type: "percentage",
          tax_value: "",
          tax_apply_per: "per_booking",
      },
      statusOptions: [
        { value: 1, text: this.$t("hotels.status_active") },
        { value: 0, text: this.$t("hotels.status_inactive") },
      ],
      countryOptions: [],
      stateOptions: [],
      cityOptions: [],
      hotelGroupOptions: [],
    };
  },

  computed: {
    isEdit() {
      return !!this.id;
    },
    ...mapGetters(['loader'])
  },

  methods: {
    handleImageChange(event) {
      this.removeError('images');
      const files = Array.from(event.target.files);
      this.images = files;
      this.previewImages = files.map((file) => URL.createObjectURL(file));
    },

    removeImage(index) {
      this.previewImages.splice(index, 1);
      this.images.splice(index, 1);

      const dataTransfer = new DataTransfer();
      this.images.forEach(file => dataTransfer.items.add(file));
      this.$refs.fileInput.$el.files = dataTransfer.files;
    },

    removeExistingImage(img, index) {
      this.imageToDelete = img;
      this.imageToDeleteIndex = index;
      this.showDeleteImageModal = true;
    },

    confirmDeleteImage() {
      this.removedImageIds.push(this.imageToDelete.id);
      this.existingImages.splice(this.imageToDeleteIndex, 1);

      this.imageToDelete = {};
      this.imageToDeleteIndex = null;

      this.$bvToast.toast(this.$t('room_types.image_marked_for_deletion'), {
        title: this.$t('common.success'),
        variant: 'success',
        solid: true,
      });
    },

    async removeError(target) {
        if (typeof target === 'object') {
            for (let i = 0; i < target.length; i++) {
              this.formErrors.remove(target[i]);
            }
        } else {
          this.formErrors.remove(target);
          const keys = Object.keys(this.formErrors.errors).filter(k => k.startsWith(target + '.'));
          keys.forEach(k => this.formErrors.remove(k));
        }
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.name
      };
    },
    async fetchHotel() {
      try {
        const response = await request({
          method: "get",
          url: `public/hotels/${this.id}`,
        });
        this.formFields = {
          ...this.formFields,
          ...response.data,
          country_id: response.data.country?.id || "",
          state_id: response.data.state?.id || "",
          city_id: response.data.city?.id || "",
          hotel_group_id: response.data.hotel_group?.id || null,
        };
        // Set existing images
        this.existingImages = response.data.galleries || [];
        if (this.formFields.country_id) {
          await this.fetchCountries();
        }
        if (this.formFields.state_id) {
          await this.fetchStates();
        }
        if (this.formFields.city_id) {
          await this.fetchCities();
        }
      } catch (error) {
        this.formLevelError =
        error.response?.data?.message || this.$t("hotels.fetch_error");
        this.notifyError(this.formLevelError);
        this.$router.push("/admin/hotels");
      }
    },

    async handleSubmit() {
      try {
        this.validated = true;
        this.formLevelError = "";
        const padTime = (val) => val && val.length === 5 ? val + ':00' : val;
        this.formFields.check_in_time = padTime(this.formFields.check_in_time);
        this.formFields.check_out_time = padTime(this.formFields.check_out_time);

        const formData = new FormData();
        // Append form fields
        for (const key in this.formFields) {
          if (this.formFields[key] !== null && this.formFields[key] !== undefined && this.formFields[key] !== '') {
            formData.append(key, this.formFields[key]);
          }
        }
        // Append new images
        this.images.forEach((file) => {
          formData.append(`images[]`, file);
        });

        // Append removed image IDs
        this.removedImageIds.forEach((id) => {
          formData.append(`delete_image_ids[]`, id);
        });
        await request({
          method: this.isEdit ? "post" : "post",
          url: this.isEdit ? `/hotels/${this.id}` : "/hotels",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            _method: this.isEdit ? "put" : "post",
          },
        });
        const successMessage = this.$t(this.id ? "hotels.update_success" : "hotels.create_success")
        this.notifySuccessWithMsg(successMessage);
        this.removedImageIds = [];
        setTimeout(() => {
          this.$router.push({name:"AdminHotels"});
        },500)
      } catch (err) {
        if(err?.data?.errors && err.status == 422){
          Object.assign(this.formErrors, new Error(err.data.errors));
          this.validated = true;
        }else{
          this.error = err.data?.message || this.$t("hotels.save_error");
          this.notifyError(this.error);
        }
      }
    },

    cancel() {
      this.removedImageIds = [];
      this.imageToDelete = {};
      this.imageToDeleteIndex = null;
      this.showDeleteImageModal = false;
      this.$router.push("/admin/hotels");
    },

    async fetchCountries() {
      try {
        const response = await request({
          method: "get",
          url: "/countries",
        });


        // response.data itself is the array
        const countries = response.data || [];
        this.countryOptions = countries.map((c) => ({
          value: c.id,
          text: c.name,
        }));

      } catch (e) {
        console.error("Error fetching countries:", e);
        this.countryOptions = [];
      }
    },

    async fetchStates() {
      try {
        const response = await request({
          method: "get",
          url: "/states",
          params: { country_id: this.formFields.country_id },
        });
        // response.data is the array directly
        const states = response.data || [];
        this.stateOptions = states.map((s) => ({
          value: s.id,
          text: s.name,
        }));
      } catch (e) {
        console.error("Error fetching states:", e);
        this.stateOptions = [];
      }
    },

    async fetchCities() {
      try {
        const response = await request({
          method: 'get',
          url: '/cities',
          params: { state_id: this.formFields.state_id }
        });
        this.cityOptions = response.data.map(c => ({ value: c.id, text: c.name }));
      } catch (e) {
        this.cityOptions = [];
      }
    },
    async fetchHotelGroups() {
      try {
        const response = await request({
          method: "get",
          url: "/public/hotel-groups",
        });

        this.hotelGroupOptions = response.data || [];
      } catch (e) {
        this.hotelGroupOptions = [];
      }
    },

    async onCountryChange() {
      this.formFields.state_id = "";
      this.formFields.city_id = "";
      await this.fetchStates();
      this.cityOptions = [];
      this.removeError("country_id");
    },

    async onStateChange() {
      this.formFields.city_id = "";
      await this.fetchCities();
      this.removeError("state_id");
    },
  },

  created() {
    this.fetchCountries();
    this.fetchHotelGroups();
    if (this.isEdit) {
      this.fetchHotel();
    }
  },
};
</script>

<style scoped>
.hotel-form {
  padding: 20px;
}

.image-preview-wrapper {
  gap: 10px;
  display: flex;
  flex-wrap: wrap;
}

.remove-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 16px;
  line-height: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-box {
  width: 100px;
  height: 100px;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-to-delete {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #e9ecef;
}
</style>
